import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
// Icons
import { Search } from "lucide-react";

import React, { useState, useEffect } from "react";
import SubAccountsData from "./components/tabledata";
import TableSkeleton from "Common/Components/Loader/TableSkeleton";

const FBSubAccounts = () => {
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const {
    loading,
    columns,
    subAccounts,
    pagination,
    searchTerm,
    handleSearch,
    handlePageChange,
    handlePageSizeChange,
    handleSort,
  } = SubAccountsData();

  // Debounce search input
  useEffect(() => {
    const timer = setTimeout(() => {
      handleSearch(debouncedSearch);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [debouncedSearch]);

  return (
    <React.Fragment>
      <BreadCrumb title="sub_accounts" pageTitle="phone_bridge" />
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <div className="card" id="subAccountTable">
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-2">
                    <input
                      type="text"
                      className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Search for name, email, phone number etc..."
                      autoComplete="off"
                      value={debouncedSearch}
                      onChange={(e) => setDebouncedSearch(e.target.value)}
                    />
                    <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                </div>
              </form>
            </div>
            {loading ? (
              <TableSkeleton />
            ) : (
              <div className="card-body">
                  <TableContainer
                    isPagination={true}
                    columns={columns || []}
                    data={subAccounts || []}
                    customPageSize={pagination.limit}
                    currentPage={pagination.page - 1} // Convert to 0-based for TableContainer
                    totalCount={pagination.total}
                    totalPages={pagination.pages}
                    onPageChange={(pageIndex) => handlePageChange(pageIndex + 1)} // Convert back to 1-based
                    onPageSizeChange={handlePageSizeChange}
                    sortField={pagination.sortField}
                    sortOrder={pagination.sortOrder}
                    onSort={handleSort}
                    divclassName="-mx-5 -mb-5 overflow-x-auto"
                    tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                    theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                    thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                    tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                    PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                  />
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FBSubAccounts;